@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources/"

@delegate:ResourceContentHash(837_395_257)
internal val Res.string.ab_plan_period_month: StringResource by lazy {
      StringResource("string:ab_plan_period_month", "ab_plan_period_month", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11070, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8538, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7486, 36),
      ))
    }

@delegate:ResourceContentHash(-345_250_691)
internal val Res.string.ab_plan_premium_f1: StringResource by lazy {
      StringResource("string:ab_plan_premium_f1", "ab_plan_premium_f1", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11119, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8575, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7523, 58),
      ))
    }

@delegate:ResourceContentHash(1_059_809_408)
internal val Res.string.ab_plan_premium_f2: StringResource by lazy {
      StringResource("string:ab_plan_premium_f2", "ab_plan_premium_f2", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11214, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8642, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7582, 54),
      ))
    }

@delegate:ResourceContentHash(554_004_788)
internal val Res.string.ab_plan_premium_f3: StringResource by lazy {
      StringResource("string:ab_plan_premium_f3", "ab_plan_premium_f3", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11289, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8721, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7637, 66),
      ))
    }

@delegate:ResourceContentHash(-1_900_878_378)
internal val Res.string.ab_plan_premium_f4: StringResource by lazy {
      StringResource("string:ab_plan_premium_f4", "ab_plan_premium_f4", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11372, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8796, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7704, 54),
      ))
    }

@delegate:ResourceContentHash(-1_480_170_541)
internal val Res.string.ab_plan_premium_f5: StringResource by lazy {
      StringResource("string:ab_plan_premium_f5", "ab_plan_premium_f5", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11463, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8855, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7759, 54),
      ))
    }

@delegate:ResourceContentHash(-173_956_245)
internal val Res.string.ab_plan_premium_name: StringResource by lazy {
      StringResource("string:ab_plan_premium_name", "ab_plan_premium_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11538, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8918, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7814, 48),
      ))
    }

@delegate:ResourceContentHash(1_094_650_628)
internal val Res.string.ab_plan_premium_price: StringResource by lazy {
      StringResource("string:ab_plan_premium_price", "ab_plan_premium_price", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11599, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8967, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7863, 33),
      ))
    }

@delegate:ResourceContentHash(962_929_250)
internal val Res.string.ab_plan_select: StringResource by lazy {
      StringResource("string:ab_plan_select", "ab_plan_select", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11702, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9050, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7934, 38),
      ))
    }

@delegate:ResourceContentHash(813_558_865)
internal val Res.string.ab_plan_selected: StringResource by lazy {
      StringResource("string:ab_plan_selected", "ab_plan_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11649, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9005, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7897, 36),
      ))
    }

@delegate:ResourceContentHash(620_880_610)
internal val Res.string.ab_plan_standard_f1: StringResource by lazy {
      StringResource("string:ab_plan_standard_f1", "ab_plan_standard_f1", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11753, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9097, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7973, 55),
      ))
    }

@delegate:ResourceContentHash(-1_990_049_817)
internal val Res.string.ab_plan_standard_f2: StringResource by lazy {
      StringResource("string:ab_plan_standard_f2", "ab_plan_standard_f2", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11825, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9165, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8029, 59),
      ))
    }

@delegate:ResourceContentHash(-408_975_153)
internal val Res.string.ab_plan_standard_f3: StringResource by lazy {
      StringResource("string:ab_plan_standard_f3", "ab_plan_standard_f3", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11913, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9233, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8089, 59),
      ))
    }

@delegate:ResourceContentHash(284_078_016)
internal val Res.string.ab_plan_standard_f4: StringResource by lazy {
      StringResource("string:ab_plan_standard_f4", "ab_plan_standard_f4", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11981, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9309, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8149, 55),
      ))
    }

@delegate:ResourceContentHash(-1_267_763_484)
internal val Res.string.ab_plan_standard_name: StringResource by lazy {
      StringResource("string:ab_plan_standard_name", "ab_plan_standard_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12057, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9385, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8205, 45),
      ))
    }

@delegate:ResourceContentHash(1_333_222_411)
internal val Res.string.ab_plan_standard_price: StringResource by lazy {
      StringResource("string:ab_plan_standard_price", "ab_plan_standard_price", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12107, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9439, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8251, 34),
      ))
    }

@delegate:ResourceContentHash(1_952_612_776)
internal val Res.string.ab_plan_subtitle: StringResource by lazy {
      StringResource("string:ab_plan_subtitle", "ab_plan_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12158, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9478, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8286, 56),
      ))
    }

@delegate:ResourceContentHash(63_326_392)
internal val Res.string.ab_plan_title: StringResource by lazy {
      StringResource("string:ab_plan_title", "ab_plan_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12267, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9539, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8343, 49),
      ))
    }

@delegate:ResourceContentHash(264_912_869)
internal val Res.string.ab_products_add_button: StringResource by lazy {
      StringResource("string:ab_products_add_button", "ab_products_add_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12357, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9613, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8393, 46),
      ))
    }

@delegate:ResourceContentHash(-159_477_090)
internal val Res.string.ab_products_add_section: StringResource by lazy {
      StringResource("string:ab_products_add_section", "ab_products_add_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12420, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9668, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8440, 51),
      ))
    }

@delegate:ResourceContentHash(5_954_002)
internal val Res.string.ab_products_added_section: StringResource by lazy {
      StringResource("string:ab_products_added_section", "ab_products_added_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12484, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9724, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8492, 53),
      ))
    }

@delegate:ResourceContentHash(-1_600_713_541)
internal val Res.string.ab_products_later_note: StringResource by lazy {
      StringResource("string:ab_products_later_note", "ab_products_later_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12546, 194),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9774, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8546, 122),
      ))
    }

@delegate:ResourceContentHash(-859_309_041)
internal val Res.string.ab_products_name: StringResource by lazy {
      StringResource("string:ab_products_name", "ab_products_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12741, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9941, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8669, 40),
      ))
    }

@delegate:ResourceContentHash(-1_300_603_701)
internal val Res.string.ab_products_price: StringResource by lazy {
      StringResource("string:ab_products_price", "ab_products_price", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12790, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9986, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8710, 41),
      ))
    }

@delegate:ResourceContentHash(-117_193_577)
internal val Res.string.ab_products_promoted_badge: StringResource by lazy {
      StringResource("string:ab_products_promoted_badge", "ab_products_promoted_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12860, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10028, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8752, 46),
      ))
    }

@delegate:ResourceContentHash(1_859_171_694)
internal val Res.string.ab_products_promoted_desc: StringResource by lazy {
      StringResource("string:ab_products_promoted_desc", "ab_products_promoted_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12907, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10079, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8799, 93),
      ))
    }

@delegate:ResourceContentHash(437_173_560)
internal val Res.string.ab_products_promoted_title: StringResource by lazy {
      StringResource("string:ab_products_promoted_title", "ab_products_promoted_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13045, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10189, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8893, 62),
      ))
    }

@delegate:ResourceContentHash(-329_185_645)
internal val Res.string.ab_products_remove_a11y: StringResource by lazy {
      StringResource("string:ab_products_remove_a11y", "ab_products_remove_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13116, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10252, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8956, 51),
      ))
    }

@delegate:ResourceContentHash(-1_861_108_545)
internal val Res.string.ab_products_skip: StringResource by lazy {
      StringResource("string:ab_products_skip", "ab_products_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13172, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10312, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9008, 40),
      ))
    }

@delegate:ResourceContentHash(322_850_275)
internal val Res.string.ab_products_subtitle: StringResource by lazy {
      StringResource("string:ab_products_subtitle", "ab_products_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13225, 308),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10365, 188),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9049, 160),
      ))
    }

@delegate:ResourceContentHash(695_609_213)
internal val Res.string.ab_products_title: StringResource by lazy {
      StringResource("string:ab_products_title", "ab_products_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13534, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10554, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9210, 53),
      ))
    }

@delegate:ResourceContentHash(749_787_920)
internal val Res.string.ab_save_draft: StringResource by lazy {
      StringResource("string:ab_save_draft", "ab_save_draft", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13604, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10612, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9264, 37),
      ))
    }

@delegate:ResourceContentHash(-385_127_805)
internal val Res.string.ab_step_label: StringResource by lazy {
      StringResource("string:ab_step_label", "ab_step_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13666, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10666, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9302, 45),
      ))
    }

@delegate:ResourceContentHash(-315_143_790)
internal val Res.string.ab_step_placeholder: StringResource by lazy {
      StringResource("string:ab_step_placeholder", "ab_step_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13724, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10716, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9348, 63),
      ))
    }

@delegate:ResourceContentHash(1_820_405_833)
internal val Res.string.ab_submit_failed: StringResource by lazy {
      StringResource("string:ab_submit_failed", "ab_submit_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13832, 204),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10784, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9412, 120),
      ))
    }

@delegate:ResourceContentHash(-2_129_438_921)
internal val Res.string.ab_submit_sign_in: StringResource by lazy {
      StringResource("string:ab_submit_sign_in", "ab_submit_sign_in", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14037, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10921, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9533, 101),
      ))
    }

@delegate:ResourceContentHash(981_952_828)
internal val Res.string.ab_submitted_body: StringResource by lazy {
      StringResource("string:ab_submitted_body", "ab_submitted_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14175, 305),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11043, 221),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9635, 197),
      ))
    }

@delegate:ResourceContentHash(1_400_206_660)
internal val Res.string.ab_submitted_done: StringResource by lazy {
      StringResource("string:ab_submitted_done", "ab_submitted_done", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14481, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11265, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9833, 33),
      ))
    }

@delegate:ResourceContentHash(-409_058_152)
internal val Res.string.ab_submitted_headline: StringResource by lazy {
      StringResource("string:ab_submitted_headline", "ab_submitted_headline", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14523, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11303, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9867, 69),
      ))
    }

@delegate:ResourceContentHash(-1_422_967_852)
internal val Res.string.ab_submitted_partial_note: StringResource by lazy {
      StringResource("string:ab_submitted_partial_note", "ab_submitted_partial_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14605, 265),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11377, 233),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9937, 181),
      ))
    }

@delegate:ResourceContentHash(1_262_553_383)
internal val Res.string.ab_submitted_title: StringResource by lazy {
      StringResource("string:ab_submitted_title", "ab_submitted_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14871, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11611, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10119, 54),
      ))
    }

@delegate:ResourceContentHash(35_704_243)
internal val Res.string.ab_wizard_brand: StringResource by lazy {
      StringResource("string:ab_wizard_brand", "ab_wizard_brand", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 14942, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11662, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10174, 35),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("ab_plan_period_month", Res.string.ab_plan_period_month)
  map.put("ab_plan_premium_f1", Res.string.ab_plan_premium_f1)
  map.put("ab_plan_premium_f2", Res.string.ab_plan_premium_f2)
  map.put("ab_plan_premium_f3", Res.string.ab_plan_premium_f3)
  map.put("ab_plan_premium_f4", Res.string.ab_plan_premium_f4)
  map.put("ab_plan_premium_f5", Res.string.ab_plan_premium_f5)
  map.put("ab_plan_premium_name", Res.string.ab_plan_premium_name)
  map.put("ab_plan_premium_price", Res.string.ab_plan_premium_price)
  map.put("ab_plan_select", Res.string.ab_plan_select)
  map.put("ab_plan_selected", Res.string.ab_plan_selected)
  map.put("ab_plan_standard_f1", Res.string.ab_plan_standard_f1)
  map.put("ab_plan_standard_f2", Res.string.ab_plan_standard_f2)
  map.put("ab_plan_standard_f3", Res.string.ab_plan_standard_f3)
  map.put("ab_plan_standard_f4", Res.string.ab_plan_standard_f4)
  map.put("ab_plan_standard_name", Res.string.ab_plan_standard_name)
  map.put("ab_plan_standard_price", Res.string.ab_plan_standard_price)
  map.put("ab_plan_subtitle", Res.string.ab_plan_subtitle)
  map.put("ab_plan_title", Res.string.ab_plan_title)
  map.put("ab_products_add_button", Res.string.ab_products_add_button)
  map.put("ab_products_add_section", Res.string.ab_products_add_section)
  map.put("ab_products_added_section", Res.string.ab_products_added_section)
  map.put("ab_products_later_note", Res.string.ab_products_later_note)
  map.put("ab_products_name", Res.string.ab_products_name)
  map.put("ab_products_price", Res.string.ab_products_price)
  map.put("ab_products_promoted_badge", Res.string.ab_products_promoted_badge)
  map.put("ab_products_promoted_desc", Res.string.ab_products_promoted_desc)
  map.put("ab_products_promoted_title", Res.string.ab_products_promoted_title)
  map.put("ab_products_remove_a11y", Res.string.ab_products_remove_a11y)
  map.put("ab_products_skip", Res.string.ab_products_skip)
  map.put("ab_products_subtitle", Res.string.ab_products_subtitle)
  map.put("ab_products_title", Res.string.ab_products_title)
  map.put("ab_save_draft", Res.string.ab_save_draft)
  map.put("ab_step_label", Res.string.ab_step_label)
  map.put("ab_step_placeholder", Res.string.ab_step_placeholder)
  map.put("ab_submit_failed", Res.string.ab_submit_failed)
  map.put("ab_submit_sign_in", Res.string.ab_submit_sign_in)
  map.put("ab_submitted_body", Res.string.ab_submitted_body)
  map.put("ab_submitted_done", Res.string.ab_submitted_done)
  map.put("ab_submitted_headline", Res.string.ab_submitted_headline)
  map.put("ab_submitted_partial_note", Res.string.ab_submitted_partial_note)
  map.put("ab_submitted_title", Res.string.ab_submitted_title)
  map.put("ab_wizard_brand", Res.string.ab_wizard_brand)
}
